import { render, staticRenderFns } from "./ConsensusTrustedReviewersSetting.vue?vue&type=template&id=2a4eb119&scoped=true&"
import script from "./ConsensusTrustedReviewersSetting.vue?vue&type=script&lang=js&"
export * from "./ConsensusTrustedReviewersSetting.vue?vue&type=script&lang=js&"
import style0 from "./ConsensusTrustedReviewersSetting.vue?vue&type=style&index=0&id=2a4eb119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4eb119",
  null
  
)

export default component.exports